import { useEffect, useRef } from 'react';
import { limparFeedBack, setFeedBack, triggerAction } from '../../component/feedback/actions';
import ilustracaoLinkExterno from '../../../assets/img/ilustracao-link-externo.svg';
import { dismissLaunchExternalLink } from 'painel/actions';
import { useDispatch } from 'react-redux';
import { getUrlVars, redirectOutside } from 'shared/helper/utilitarioUrl';
import { useLocation } from 'react-router-dom';
import history from '../../../history';


export function useExternalLinkHandler({
    feedback,
    launchExternalLink
}) {
    const dispatch = useDispatch();
    const location = useLocation();
    const jaVoltou = useRef(false); // previne loop

    function limparLinkExterno() {
        dispatch(dismissLaunchExternalLink());
        dispatch(limparFeedBack());
    }

    // Ações disparadas pelo feedback
    useEffect(() => {
        const { triggeredActionId } = feedback || {};
        if (triggeredActionId?.startsWith('layout/')) {
            switch (triggeredActionId) {
                case 'layout/voltar':
                case 'layout/cancelar-link-externo':
                    limparLinkExterno();
                    break;
                case 'layout/abrir-link-externo':
                    limparLinkExterno();
                    let urlSemTemp = launchExternalLink.substring(0, launchExternalLink.indexOf("?TEMP="));
                    setTimeout(() => redirectOutside(urlSemTemp), 0);
                    break;
                default:
                    break;
            }
        }
    }, [feedback, feedback?.triggeredActionId, launchExternalLink]);

    // Controle do link externo
    useEffect(() => {

        let wasFeedback = getUrlVars()['feedback']
        let isLogin = location.pathname.startsWith('/login');

        if (isLogin && wasFeedback){
            limparLinkExterno();
            history.replace(location.pathname);
            return;
        }

        if (launchExternalLink && !location.pathname?.includes('/aberto/tela-info')) {
            jaVoltou.current = false; // reset no flag
            dispatch(setFeedBack({
                icon: ilustracaoLinkExterno,
                title: 'Aviso',
                description: 'Ao avançar, você irá para uma página fora do Meu INSS.',
                primaryAction: triggerAction('layout/abrir-link-externo'),
                primaryActionLabel: 'Avançar',
                secondaryAction: triggerAction('layout/cancelar-link-externo'),
                secondaryActionLabel: 'Cancelar'
            }));
            history.replace(location.pathname + (isLogin ? "?feedback=true" : ''))
            history.push("/aberto/tela-info");
        }
        // só volta se o link for nulo, estiver na tela info, e ainda não voltou
        else if (
            !launchExternalLink &&
            location.pathname?.includes('/aberto/tela-info') &&
            !jaVoltou.current
        ) {
            jaVoltou.current = true; // evita loop
            setTimeout(() => {
                limparLinkExterno();
                jaVoltou.current = true; // evita loop
                setTimeout(() => history.goBack(), 0);
            } , 0);
        }

    }, [launchExternalLink]);
}
